import React from 'react';

import cn from 'classnames';

import { IConDefaultType } from '../..';

export enum CrownIconVariant {
  DEFAULT = 'default',
}
export interface ICrownIconProps extends IConDefaultType {
  variant?: CrownIconVariant;
}

export default function CrownIcon({
  color,
  className,
  size = 24,
  rotate,
  flip,
  variant = CrownIconVariant.DEFAULT,
}: ICrownIconProps) {
  const style = {
    width: size,
    minWidth: size,
    height: size,
    transform: `rotate(${rotate}deg)`,
  };

  return (
    <i className={cn('dds-icon', className, { flip })} style={style}>
      {variant === CrownIconVariant.DEFAULT && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
          <path
            d="M2 17.1579C2 16.6928 2.37702 16.3158 2.84211 16.3158H17.1579C17.623 16.3158 18 16.6928 18 17.1579C18 17.623 17.623 18 17.1579 18H2.84211C2.37702 18 2 17.623 2 17.1579ZM2 6.34064C2 5.55309 2.86812 5.07461 3.53399 5.49515L6 7.05263L9.21596 2.99037C9.61633 2.48464 10.3837 2.48464 10.7841 2.99037L14 7.05263L16.466 5.49515C17.1319 5.07461 18 5.55309 18 6.34064V13.6316C18 14.1839 17.5523 14.6316 17 14.6316H3C2.44772 14.6316 2 14.1839 2 13.6316V6.34064Z"
            fill="#303037"
          />
        </svg>
      )}
    </i>
  );
}
